<template>
  <!-- Page length options -->
  <section>
    <div class="card">
      <div
        v-show="onload"
        class="content bg-white"
      >
        <placeholder-content is-load="true" />
      </div>
      <div v-if="!onload && !hasPermission">
        <access-denied />
      </div>
      <div v-else>
        <div
          v-if="!onload"
          class="card-header bg-white header-elements-inline"
        >
          <h5 class="card-title">
            {{ $t("Sales Report By Payment Channel") }}
          </h5>
        </div>
        <div
          v-if="!onload"
          class="card-body"
        >
          <div class="card-filter d-flex  align-items-center bg-light mt-n3 mx-n3 mb-3  pt-3 pb-3 pl-3 pr-3 border-bottom">
            <div>{{ $t("Data Duration") }}</div>
            <div class="toolbar-filter pl-2 mb-0">
              <div class="btn-group">
                <div class="filter-date">
                  <div class="input-group">
                    <span class="input-group-prepend">
                      <span class="input-group-text"><i class="fas fa-calendar-alt " /></span>
                    </span>
                    <date-range-picker
                      style="min-width: 175px"
                      opens="right"
                      :ranges="ranges"
                      v-model="filter.dateRange"
                      :locale-data="localedata"
                      :control-container-class="'form-control rounded-left-0'"
                      @update="applyDatePicker"
                    >
                      <div
                        slot="input"
                        v-html="showTextPicker"
                      />
                      <div
                        slot="footer"
                        slot-scope="data"
                        class="p-2 drp-buttons"
                      >
                        <button
                          @click="cancelDateRange()"
                          v-if="!data.in_selection"
                          type="button"
                          class="applyBtn btn btn-sm btn-secondary"
                        >
                          {{ $t("Cancel") }}
                        </button>
                        <button
                          @click="data.clickApply"
                          v-if="!data.in_selection"
                          type="button"
                          class="applyBtn btn btn-sm btn-primary"
                        >
                          {{ $t("Apply") }}
                        </button>
                      </div>
                    </date-range-picker>
                  </div>
                </div>
              </div>
            </div>
          </div>
           

          <div
            v-if="!onload"
            class="d-flex flex-wrap"
          >
            <div class="card mr-3">
              <div class="card-body">
                <span class="rounded-circle badge badge-icon bg-primary position-absolute top-0 right-0 mt-3 mr-3"><i
                  style="font-size: 11px;"
                  class="fa-solid fa-sack-dollar"
                /></span>
                <h6 class="mb-0 font-weight-semibold">
                  {{ $t('_Dashboard.Sale') }}
                </h6>
                <h3 class="text-grey-800 font-weight-semibold my-1">
                  ฿{{ payments.total | formatNumber }}
                </h3>
                <div
                  v-if="orders.percent == '-' || orders.percent == 0"
                  class="text-grey-300"
                >
                  <span class="mr-1">0.00%</span> {{ $t('compared to last month') }}
                </div>
                <div
                  v-else
                  class="text-grey-300"
                >
                  <span :class="[payments.percent >= 0? 'text-green-custom': 'text-danger', 'mr-1']"><i :class="[payments.percent >= 0? 'fa-arrow-up': 'fa-arrow-down', 'fas mr-1']" />{{ payments.percent | formatNumber }}% </span> {{ $t('compared to last month') }}
                </div>
              </div>
            </div>

            <div class="card mr-3">
              <div class="card-body">
                <span class="rounded-circle badge badge-icon bg-primary position-absolute top-0 right-0 mt-3 mr-3"><i
                  style="font-size: 11px;"
                  class="fa-solid fa-box"
                /></span>
                <h6 class="mb-0 font-weight-semibold">
                  {{ $t('Number Product') }}
                </h6>
                <h3 class="text-grey-800 font-weight-semibold my-1">
                  {{ ordersItemAmount.total | formatNumberNotDecimal }}
                </h3>
                <div
                  v-if="ordersItemAmount.percent == '-' || ordersItemAmount.percent == 0"
                  class="text-grey-300"
                >
                  <span class="mr-1">0.00%</span> {{ $t('compared to last month') }}
                </div>
                <div
                  v-else
                  class="text-grey-300"
                >
                  <span :class="[ordersItemAmount.percent >= 0? 'text-green-custom': 'text-danger', 'mr-1']"><i :class="[ordersItemAmount.percent >= 0? 'fa-arrow-up': 'fa-arrow-down', 'fas mr-1']" />{{ ordersItemAmount.percent | formatNumber }}% </span> {{ $t('compared to last month') }}
                </div>
              </div>
            </div>

            <div class="card mr-3">
              <div class="card-body">
                <span class="rounded-circle badge badge-icon bg-primary position-absolute top-0 right-0 mt-3 mr-3"><i class="fas fa-shopping-cart" /></span>
                <h6 class="mb-0 font-weight-semibold">
                  {{ $t('Number of orders') }}
                </h6>
                <h3 class="text-grey-800 font-weight-semibold my-1">
                  {{ orders.total | formatNumberNotDecimal }}
                </h3>
                <div
                  v-if="orders.percent == '-' || orders.percent == 0"
                  class="text-grey-300"
                >
                  <span class="mr-1">0.00%</span> {{ $t('compared to last month') }}
                </div>
                <div
                  v-else
                  class="text-grey-300"
                >
                  <span :class="[orders.percent >= 0? 'text-green-custom': 'text-danger', 'mr-1']"><i :class="[orders.percent >= 0? 'fa-arrow-up': 'fa-arrow-down', 'fas mr-1']" />{{ orders.percent | formatNumber }}% </span> {{ $t('compared to last month') }}
                </div>
              </div>
            </div>
          </div>
          <ChartPiePayment
            v-if="!onload"
            :pie-chart="pieChart"
            :filter-date="filter.dateRange"
            class="pb-3"
          />
          <TablePayment
            v-if="!onload"
            :pie-chart="pieChart"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import PlaceholderContent from "@/plugins/PlaceholderContent.vue";
import DateRangePicker from "vue2-daterange-picker";
import {
    showTextPicker,
} from "../assets/directives/Vuetable.js";
import {
    convertTimezone
} from "@/common/tenancy/convertTimezone";

import Api from '@/services/endpoint/tenant.service'
import numeral from "numeral";
import moment from "moment";
import {
    mounted
} from '../../../../../plugins/summernote.js';
import AccessDenied from "@/components/tenancy/admin/error-page/templates/AccessDenied.vue";
import ChartPiePayment from "./ChartPiePayment.vue"
import TablePayment from "./table/TablePayment.vue"

export default {
    components: {
        PlaceholderContent,
        DateRangePicker,
        AccessDenied,
        ChartPiePayment,
        TablePayment,
    },
    data() {
        return {
            hasPermission:true,
            onload: true,
            paramsQuery: {
                dateRange: {
                    startDate: this.$route.query.start_date != undefined ? this.$route.query.start_date : moment().subtract(1, 'months').format('YYYY-MM-DD'),
                    endDate: this.$route.query.end_date != undefined ? this.$route.query.end_date : moment().format('YYYY-MM-DD'),
                },
                payment_name: this.$route.query.payment_name != undefined ? this.$route.query.payment_name : 'ALL',
                state: this.$route.query.state != undefined ? this.$route.query.state : 'ALL',
            },
            localedata: {
                format: 'DD-MM-YYYY',
                applyLabel: this.$t('Apply'),
                cancelLabel: this.$t('Cancel'),
                clearable: true,
                monthNames: this.$storeIndex.monthNames(),
                daysOfWeek: this.$storeIndex.daysOfWeek(),
            },
            ranges: this.$storeIndex.ranges(),
            orders: [],
            payments: [],
            chartColumns: [],
            paymentMethod: [],
            firstLoad: true,
            filter: {
                dateRange: {
                    startDate: moment().subtract(1, 'months').format('YYYY-MM-DD'),
                    endDate: moment().format('YYYY-MM-DD'),
                },
            },
            pieChart:null,
            ordersItemAmount:[],
        };
    },
    async mounted() {
        this.fetchSalesorderPayment();
    },
    computed: {
        showTextPicker: function () {
            if (this.filter.dateRange.startDate && this.filter.dateRange.endDate) {
                return this.setFormatDate();
            } else {
                return showTextPicker(this.filter.dateRange);
            }
        }
    },
    methods: {
        setFormatDate() {
            this.filter.dateRange.startDate = convertTimezone.utcToLocal(this.filter.dateRange.startDate, false).format('YYYY-MM-DD');
            this.filter.dateRange.endDate = convertTimezone.utcToLocal(this.filter.dateRange.endDate, false).format('YYYY-MM-DD');
            this.dateTxtFilter = showTextPicker(this.filter.dateRange);
            return this.dateTxtFilter;
        },
        cancelDateRange() {
            $(".daterangepicker").remove();
            this.onload = true;
            setTimeout(() => this.onload = false , 500)
        },
        applyDatePicker(dateRange) {
           
            this.filter.dateRange.startDate = moment(dateRange.startDate).format("YYYY-MM-DD");
            this.filter.dateRange.endDate = moment(dateRange.endDate).format("YYYY-MM-DD");
            this.fetchSalesorderPayment();
        },
        async fetchSalesorderPayment() {
            this.onload = true;
            let reqPayment = null;
            
            reqPayment = await Api.PaymentMethod.getPaymentMethod('?' + $.param({ report: 'ReportTotalPayments' }));
            if(reqPayment.status == 403){   
                this.onload = false;
                this.hasPermission = false; 
                return;
            }

            const queryString = new URLSearchParams({
                startDate: convertTimezone.localToUtc(moment(this.filter.dateRange.startDate).startOf('day'), false).format('YYYY-MM-DD HH:mm:ss'),
                endDate: convertTimezone.localToUtc(moment(this.filter.dateRange.endDate).endOf('day'), false).format('YYYY-MM-DD HH:mm:ss'),
                state: 'ALL',
            }).toString()

            await Api.Report.getSalesOrderTotalPayments(queryString).then((res) => {
                let salesorder = res.data;
                this.orders = salesorder.orders;
                this.payments = salesorder.payments;
                this.ordersItemAmount = salesorder.ordersItemAmount
                const pieDataMonthAgo = salesorder.pieDataMonthAgo

                const allPayment = reqPayment.data.data;
                const [value,total,itemQty,growthRate]  = [0,0,0,0]
                const pie = allPayment.map(item => {
                    return {
                        id:item.global_id,
                        name:item.name,
                        value,
                        total,
                        itemQty,
                        growthRate,
                        logo:item.logo
                    }
                });
                const pieChart = [];

                const calculateGrowrate = (ago,now) => {
                    ago = +(ago)
                    now = +(now)

                    if(!ago && now) return 100
                    if(!ago && !now) return 0
                    return ((now - ago) / ago) * 100
                }

                pie.map(item => {

                    //about selected data

                    const search = salesorder.pieData.filter(function(pieData) {
                        return item.id === pieData.payment_method.global_id;
                    });

                        if(search.length > 0) {
                            item.value = +(search[0].orderAmountTotal)
                            item.total = +(search[0].orderPaidTotal)
                            item.itemQty = +(search[0].item_amount)
                        }
                    //about compare
                        const searchCompare = pieDataMonthAgo.filter(mto => mto.payment_method_id == item.id)[0]
                    
                        const monthAgo = searchCompare ?  +(searchCompare['orderPaidTotal']) : 0;
                        const total = item.total

                        item.growthRate = calculateGrowrate(monthAgo,total)

                        pieChart.push(item)
                })
                this.pieChart = pieChart
            }).catch((error) => {
                console.error({error});
                if (error.response.status === 403) {
                    this.hasPermission = true;
                } else {
                    this.$router.push({name: "t.a.home"});
                    console.log(error.response.status, 'error');
                }
            });

            this.$nextTick(() => {
                this.onload = false;
                this.firstLoad = false;
            });
        },
        setQuerystring(obj) {
            this.$router.push({
                query: Object.assign({}, this.$route.query, obj)
            }).catch(() => {});
        },
        toQueryString(){
            let queryString = "";
            const { dateRange, ...obj } = this.filter;
            if (this.filter) {
                queryString += $.param({...obj,...dateRange});
            }
            return queryString+"&state=ALL";
        },
    },

    filters: {
        formatNumber: function (value) {
            if (value == '-') {
                value = 0;
            }
            return numeral(value).format("0,0.00");
        },
        formatNumberNotDecimal: function (value) {
            if (value == '-') {
                value = 0;
            }
            return numeral(value).format("0,0");
        },
    },

}
</script>



// WEBPACK FOOTER //
// src/components/tenancy/admin/report/finance/PaymentReport.vue